/**
 * @file MaterialHeader.jsx
 * @description Material Design 3 header component
 */

import React from "react";
import { Icon } from "./Icon";

const site_logo = require("../assets/media/logo192.png");

export const MaterialHeader = ({ 
  variant = "default", // "default", "back", "close", "create"
  title = null,
  onBack = null,
  onClose = null,
  hideSettings = false
}) => {
  const handleLogoClick = () => {
    // Logo click handler - could add TTS or other functionality here
  };

  return (
    <>
      {/* Top App Bar */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        padding: '0 16px', 
        height: '64px',
        backgroundColor: 'var(--md-sys-color-surface-container)',
        borderBottom: '1px solid var(--md-sys-color-outline-variant)'
      }}>
        {/* Left Action Button */}
        {variant === "back" ? (
          <md-icon-button onClick={onBack || (() => window.history.back())}>
            <Icon name="back" />
          </md-icon-button>
        ) : variant === "close" || variant === "create" ? (
          <md-icon-button onClick={onClose}>
            <Icon name="close" />
          </md-icon-button>
        ) : null}

        {/* Logo and Title */}
        {variant === "default" ? (
          <a 
            href="/"
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginLeft: '16px',
              cursor: 'pointer',
              textDecoration: 'none',
              color: 'inherit'
            }}
            onClick={handleLogoClick}
          >
            <img
              src={site_logo}
              alt="memorize.life bible logo"
              style={{
                width: "32px",
                height: "32px",
                marginRight: "12px"
              }}
            />
            <span style={{ 
              fontSize: '22px', 
              fontWeight: '400',
              color: 'var(--md-sys-color-on-surface)'
            }}>
              memorize.life
            </span>
          </a>
        ) : variant === "create" ? (
          <div style={{ 
            marginLeft: '16px',
            fontSize: '20px', 
            fontWeight: '500',
            color: 'var(--md-sys-color-on-surface)',
            flex: 1
          }}>
            {title || "Make a Challenge"}
          </div>
        ) : (
          <div style={{ 
            marginLeft: '16px',
            fontSize: '20px', 
            fontWeight: '500',
            color: 'var(--md-sys-color-on-surface)'
          }}>
            {title || "memorize.life"}
          </div>
        )}

        {/* Spacer */}
        {variant !== "create" && <div style={{ flex: 1 }} />}

        {/* Right Action Button */}
        {!hideSettings && variant !== "create" ? (
          <md-icon-button
            href="/settings"
            title="Settings"
          >
            <Icon name="settingsTab" />
          </md-icon-button>
        ) : null}
      </div>
    </>
  );
};
